import { omit } from 'lodash'
import { z } from 'zod'

export const paginationSchema = z
  .object({
    count: z.number().nonnegative(),
    more: z.boolean(),
    page: z.number().positive(),
    page_size: z.number().positive(),
  })
  .transform((data) => ({
    ...omit(data, 'page_size'),
    pageSize: data.page_size,
  }))
  .describe('Pagination')

export const paginationQueryParametersSchema = z
  .object({
    page: z.number().positive().default(1),
    pageSize: z.number().positive().default(10),
  })
  .default({ page: 1, pageSize: 10 })
  .describe('Pagination Query Parameters')

export type ApiPagination = z.infer<typeof paginationSchema>

export type PaginationQueryParameters = z.infer<
  typeof paginationQueryParametersSchema
>

export const defaultPagination = {
  page: 1,
  pageSize: 10,
  more: false,
  count: 0,
} as ApiPagination
